export const BASE_URL = 'https://www.oxfordstudycenter.online';
